module.exports = __webpack_public_path__ + "static/media/hover-4.7614bbf0.svg";